import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "-search-sticky",
  "data-scroll": "",
  "data-scroll-repeat": ""
}
const _hoisted_2 = { class: "c-programmes-search u-bg-color-6 -search-margin-top" }
const _hoisted_3 = { class: "o-container" }
const _hoisted_4 = { class: "o-form" }
const _hoisted_5 = { class: "o-form__item__container" }
const _hoisted_6 = { class: "o-form__item" }
const _hoisted_7 = {
  class: "o-label sr-only",
  for: "programmes-search"
}
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -ico-search",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "search"),
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#search" })
], -1 /* HOISTED */)
const _hoisted_10 = {
  key: 0,
  class: "o-form__item"
}
const _hoisted_11 = {
  class: "o-label sr-only",
  for: "year"
}
const _hoisted_12 = { value: "" }
const _hoisted_13 = ["value"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -ico-arrow-down",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "arrow-down"),
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-down" })
], -1 /* HOISTED */)
const _hoisted_15 = {
  key: 1,
  class: "o-form__item"
}
const _hoisted_16 = {
  class: "o-label sr-only",
  for: "theme"
}
const _hoisted_17 = { value: "" }
const _hoisted_18 = ["value"]
const _hoisted_19 = ["value"]
const _hoisted_20 = ["value"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -ico-arrow-down",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "arrow-down"),
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-down" })
], -1 /* HOISTED */)
const _hoisted_22 = { class: "o-form__button c-tooltip__wrap" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "o-button__icos" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "o-button__ico" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "o-ico -ico-search-category",
      role: "img"
    }, [
      /*#__PURE__*/_createElementVNode("title", null, "search-category"),
      /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#search-category" })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "o-button__ico" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "o-ico -ico-search-category",
      role: "img"
    }, [
      /*#__PURE__*/_createElementVNode("title", null, "search-category"),
      /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#search-category" })
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "c-tooltip" }
const _hoisted_26 = { class: "c-tooltip__text" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "js-events-results-count" }, "0", -1 /* HOISTED */)
const _hoisted_28 = { class: "c-programmes-search__filters" }
const _hoisted_29 = { class: "o-container" }
const _hoisted_30 = { class: "c-programmes-search__filters__wrap" }
const _hoisted_31 = { class: "c-programmes-search__filters__total" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "js-events-results-count" }, "0", -1 /* HOISTED */)
const _hoisted_33 = { class: "c-programmes-search__filters__actives" }
const _hoisted_34 = { class: "c-programmes-search__filters__actives__item" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */)
const _hoisted_38 = { class: "sr-only" }
const _hoisted_39 = { class: "c-programmes-search__filters__reset" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "c-loader" }, null, -1 /* HOISTED */)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("label", _hoisted_7, _toDisplayString($options.t("Mots clés")), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  onKeyup: _cache[0] || (_cache[0] = $event => ($options.keyupSearch())),
                  class: "o-input",
                  id: "programmes-search",
                  type: "text",
                  placeholder: $options.t('Mots clés'),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.searchInput) = $event))
                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_8), [
                  [_vModelText, $data.searchInput]
                ]),
                _hoisted_9
              ]),
              ($data.years.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("label", _hoisted_11, _toDisplayString($options.t("Année")), 1 /* TEXT */),
                    _withDirectives(_createElementVNode("select", {
                      onChange: _cache[2] || (_cache[2] = $event => ($options.changeSelectionYear())),
                      class: "o-select",
                      id: "year",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.selectedYear) = $event))
                    }, [
                      _createElementVNode("option", _hoisted_12, _toDisplayString($options.t("Année")), 1 /* TEXT */),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.years, (year) => {
                        return (_openBlock(), _createElementBlock("option", { value: year }, _toDisplayString(year), 9 /* TEXT, PROPS */, _hoisted_13))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                      [_vModelSelect, $data.selectedYear]
                    ]),
                    _hoisted_14
                  ]))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" <div v-if=\"publics.length > 0\" class=\"o-form__item\">\n                        <label class=\"o-label sr-only\" for=\"theme\">{{ t(\"Publics cibles\") }}</label>\n                        <select @change=\"changeSelectionPublic()\" ref=\"theme\" class=\"o-select\" id=\"theme\"\n                            v-model=\"selectedPublic\">\n                            <option value=\"\">{{ t(\"Publics cibles\") }}</option>\n                            <template v-for=\"category in publics\">\n                                <option v-if=\"category.parent === null\" :value=\"category.id\">{{ category.title }}\n                                </option>\n                                <template v-if=\"category.parent === null && hasChilds(category, publics)\"\n                                    v-for=\"child in publics\">\n                                    <option v-if=\"child.parent === category.id\" :value=\"child.id\">&mdash; {{ child.title\n                                        }}</option>\n                                    <template v-if=\"child.parent === category.id && hasChilds(child, publics)\"\n                                        v-for=\"children in publics\">\n                                        <option v-if=\"children.parent === child.id\" :value=\"children.id\">&mdash;&mdash;\n                                            {{ children.title }}</option>\n                                    </template>\n                                </template>\n                            </template>\n                        </select>\n                        <svg class=\"o-ico -ico-arrow-down\" role=\"img\">\n                            <title>arrow-down</title>\n                            <use xlink:href=\"/assets/img/sprite.svg?v=2#arrow-down\"></use>\n                        </svg>\n                    </div>\n                    <div v-if=\"types.length > 0\" class=\"o-form__item\">\n                        <label class=\"o-label sr-only\" for=\"theme\">{{ t(\"Types\") }}</label>\n                        <select @change=\"changeSelectionType()\" ref=\"theme\" class=\"o-select\" id=\"theme\"\n                            v-model=\"selectedType\">\n                            <option value=\"\">{{ t(\"Types\") }}</option>\n                            <template v-for=\"category in types\">\n                                <option v-if=\"category.parent === null\" :value=\"category.id\">{{ category.title }}\n                                </option>\n                                <template v-if=\"category.parent === null && hasChilds(category, types)\"\n                                    v-for=\"child in types\">\n                                    <option v-if=\"child.parent === category.id\" :value=\"child.id\">&mdash; {{ child.title\n                                        }}</option>\n                                    <template v-if=\"child.parent === category.id && hasChilds(child, types)\"\n                                        v-for=\"children in types\">\n                                        <option v-if=\"children.parent === child.id\" :value=\"children.id\">&mdash;&mdash;\n                                            {{ children.title }}</option>\n                                    </template>\n                                </template>\n                            </template>\n                        </select>\n                        <svg class=\"o-ico -ico-arrow-down\" role=\"img\">\n                            <title>arrow-down</title>\n                            <use xlink:href=\"/assets/img/sprite.svg?v=2#arrow-down\"></use>\n                        </svg>\n                    </div>\n                    <div v-if=\"modes.length > 0\" class=\"o-form__item\">\n                        <label class=\"o-label sr-only\" for=\"theme\">{{ t(\"Mode\") }}</label>\n                        <select @change=\"changeSelectionMode()\" ref=\"theme\" class=\"o-select\" id=\"theme\"\n                            v-model=\"selectedMode\">\n                            <option value=\"\">{{ t(\"Mode\") }}</option>\n                            <template v-for=\"category in modes\">\n                                <option :value=\"category.id\">{{ t(category.title) }}\n                                </option>\n                            </template>\n                        </select>\n                        <svg class=\"o-ico -ico-arrow-down\" role=\"img\">\n                            <title>arrow-down</title>\n                            <use xlink:href=\"/assets/img/sprite.svg?v=2#arrow-down\"></use>\n                        </svg>\n                    </div> "),
              ($data.categories.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("label", _hoisted_16, _toDisplayString($options.t("Thématiques")), 1 /* TEXT */),
                    _withDirectives(_createElementVNode("select", {
                      onChange: _cache[4] || (_cache[4] = $event => ($options.changeSelectionCategory())),
                      ref: "theme",
                      class: "o-select",
                      id: "theme",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($data.selectedCategory) = $event))
                    }, [
                      _createElementVNode("option", _hoisted_17, _toDisplayString($options.t("Thématiques")), 1 /* TEXT */),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.categories, (category) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                          (category.parent === null)
                            ? (_openBlock(), _createElementBlock("option", {
                                key: 0,
                                value: category.id
                              }, _toDisplayString(category.title), 9 /* TEXT, PROPS */, _hoisted_18))
                            : _createCommentVNode("v-if", true),
                          (category.parent === null && $options.hasChilds(category, $data.categories))
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($data.categories, (child) => {
                                return (_openBlock(), _createElementBlock(_Fragment, null, [
                                  (child.parent === category.id)
                                    ? (_openBlock(), _createElementBlock("option", {
                                        key: 0,
                                        value: child.id
                                      }, "— " + _toDisplayString(child.title), 9 /* TEXT, PROPS */, _hoisted_19))
                                    : _createCommentVNode("v-if", true),
                                  (child.parent === category.id && $options.hasChilds(child, $data.categories))
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($data.categories, (children) => {
                                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                                          (children.parent === child.id)
                                            ? (_openBlock(), _createElementBlock("option", {
                                                key: 0,
                                                value: children.id
                                              }, "—— " + _toDisplayString(children.title), 9 /* TEXT, PROPS */, _hoisted_20))
                                            : _createCommentVNode("v-if", true)
                                        ], 64 /* STABLE_FRAGMENT */))
                                      }), 256 /* UNKEYED_FRAGMENT */))
                                    : _createCommentVNode("v-if", true)
                                ], 64 /* STABLE_FRAGMENT */))
                              }), 256 /* UNKEYED_FRAGMENT */))
                            : _createCommentVNode("v-if", true)
                        ], 64 /* STABLE_FRAGMENT */))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                      [_vModelSelect, $data.selectedCategory]
                    ]),
                    _hoisted_21
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("button", {
                  class: "o-button -button-bg js-advanced-search-button",
                  onClick: _cache[6] || (_cache[6] = _withModifiers((...args) => (_ctx.toggleAdvancedSearch && _ctx.toggleAdvancedSearch(...args)), ["prevent"])),
                  "aria-label": "Ouvrir et/ou fermer la recherche"
                }, _hoisted_24),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("span", _hoisted_26, [
                    _createTextVNode(_toDisplayString($options.t("Voir les")) + " ", 1 /* TEXT */),
                    _hoisted_27,
                    _createTextVNode(" " + _toDisplayString($options.t("résultats")), 1 /* TEXT */)
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("span", null, [
              _hoisted_32,
              _createTextVNode(" " + _toDisplayString($options.t("résultats")), 1 /* TEXT */)
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.tags, (tag) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _createElementVNode("button", {
                  class: "c-programmes-search__filters__remove",
                  onClick: _withModifiers($event => ($options.removeTag(tag)), ["prevent"])
                }, [
                  _hoisted_36,
                  _hoisted_37,
                  _createElementVNode("span", _hoisted_38, _toDisplayString($options.t("Retirer le filtre")) + " : " + _toDisplayString(tag.title), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_35),
                _createElementVNode("span", null, _toDisplayString(tag.title), 1 /* TEXT */)
              ]))
            }), 256 /* UNKEYED_FRAGMENT */))
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("button", {
              class: "o-button -button-reset",
              onClick: _cache[7] || (_cache[7] = _withModifiers((...args) => ($options.resetSearch && $options.resetSearch(...args)), ["prevent"]))
            }, _toDisplayString($options.t("Réinitialiser la recherche")), 1 /* TEXT */)
          ])
        ])
      ])
    ]),
    _hoisted_40
  ], 64 /* STABLE_FRAGMENT */))
}